import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateFaqCategoryRequest extends BaseUpdateRequest {
    name = '';  
}